import axios from 'axios';

export const GATEWAY_URL = process.env.REACT_APP_GATEWAY_URL;
export const GATEWAY_TOKEN = process.env.REACT_APP_GATEWAY_TOKEN;

export const FILE_URL = `${process.env.REACT_APP_FILE_URL}`;
const APP_API_URL = process.env.REACT_APP_API_URL;
const API_URL_APP = process.env.REACT_APP_API;

const GetAPI = () => {
const hostname =  window.location.hostname;

  if (hostname?.includes('localhost')|| hostname?.includes('192.168.2.136') ) {
    return APP_API_URL;
  }
  else{
      const listArr = hostname.split('.');
      const apiUrl = APP_API_URL
      return apiUrl 
}};
export const API_URL = GetAPI();
export const HOST_API = `${API_URL}/api/v1/`;

export const requestGET = async (URL) => {
  try {
    const res = await axios({
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      url: `${API_URL}/${URL}`,
    });
    return res.data;
  } catch (error) {
    return null;
  }
};

export const requestPOST = async (URL, data) => {
  try {
    const res = await axios({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      url: `${API_URL}/${URL}`,
      data,
    });

    return res.data;
  } catch (error) {
    return null;
  }
};
export const requestPOSTRoot = async (URL, data) => {
  try {
    const res = await axios({
      method: 'POST',
      headers: {
        tenant: 'root',
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      url: `${API_URL}/${URL}`,
      data,
    });

    return res.data;
  } catch (error) {
    return null;
  }
};

export const requestPOST_NEW = async (URL, data) => {
  try {
    const res = await axios({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      url: `${API_URL}/${URL}`,
      data,
    });

    return res;
  } catch (error) {
    return error?.response ?? null;
  }
};

export const requestPUT_NEW = async (URL, data) => {
  try {
    const res = await axios({
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      url: `${API_URL}/${URL}`,
      data,
    });

    return res;
  } catch (error) {
    return error?.response ?? null;
  }
};

export const requestDOWNLOADFILE = async (URL, data) => {
  try {
    const res = await axios({
      method: 'POST',
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
      },
      url: `${API_URL}/${URL}`,
      data,
    });

    return res;
  } catch (error) {
    return null;
  }
};

export const requestPUT = async (URL, data) => {
  try {
    const res = await axios({
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      url: `${API_URL}/${URL}`,
      data,
    });

    return res.data;
  } catch (error) {
    return null;
  }
};

export const requestDELETE = async (URL) => {
  try {
    const res = await axios({
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      url: `${API_URL}/${URL}`,
    });

    return res.data;
  } catch (error) {
    return null;
  }
};

